import * as Sentry from '@sentry/browser'

export default defineNuxtRouteMiddleware(async (to) => {
  try {
    const { getEffectiveAuthToken } = useEffectiveAuthToken()
    const token = await getEffectiveAuthToken()
    const chromeExtensionStore = useChromeExtensionStore()
    const { extension } = storeToRefs(chromeExtensionStore)
    if (to.query?.eid) {
      extension.value = {
        eid: String(to.query?.eid),
        page: String(to.query?.page),
        detail: String(to.query?.detail)
      }
      if (token) {
        chromeExtensionStore.login()
        if (to.query?.['open-chat'] === 'true') {
          return useIntercom().show()
        }
        if (to.path === '/') {
          return navigateTo('/chrome-extension/')
        }
        return
      }
    }
    chromeExtensionStore.sendCurrentPage(to.fullPath)
  } catch (error) {
    Sentry.captureException(error)
    const snackbar = useSnackbar()
    snackbar.error('An error occurred in the Chrome Extension middleware.')
  }
})
